export default __webpack_public_path__ + "static/media/site-active.3889b3d9.svg";